export function OnlineIndicator({ online }: { online: boolean }) {
  return (
    <div className="connection-indicator" aria-live="polite">
      <span className={`dot ${online ? "online" : ""}`} aria-hidden />
      <span className="connection-label">{online ? "Online" : "Offline"}</span>
    </div>
  );
}
